import React from 'react'
import { Layout } from '../../layout'
import { ChartFDI } from './chartFDI'
import { ChartIndustryFDI } from './chartIndustryFDI'

export const FdiChart = () => {
  return (
    <Layout>
      <ChartFDI />
      <ChartIndustryFDI />
    </Layout>
  )
}
